import { render, staticRenderFns } from "./MaterialCreate.vue?vue&type=template&id=57446874"
import script from "./MaterialCreate.vue?vue&type=script&lang=js"
export * from "./MaterialCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports